const BASE = '/api';

async function req(method, path, body) {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: body ? { 'Content-Type': 'application/json' } : {},
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) throw new Error(`${method} ${path} → ${res.status}`);
  return res.json();
}

export const api = {
  // Deals
  getDeals:   ()           => req('GET',    '/deals'),
  getDeal:    (id)         => req('GET',    `/deals/${id}`),
  createDeal: (data)       => req('POST',   '/deals', data),
  updateDeal: (id, data)   => req('PATCH',  `/deals/${id}`, data),
  deleteDeal: (id)         => req('DELETE', `/deals/${id}`),

  // Cost lines  (table = 'frontend_costs' | 'backend_costs' | 'holding_costs')
  updateCostLine: (dealId, table, id, data) => req('PATCH',  `/deals/${dealId}/${table}/${id}`, data),
  addCostLine:    (dealId, table, data)     => req('POST',   `/deals/${dealId}/${table}`, data),
  deleteCostLine: (dealId, table, id)       => req('DELETE', `/deals/${dealId}/${table}/${id}`),

  // Expenses
  addExpense:    (dealId, data)     => req('POST',   `/deals/${dealId}/expenses`, data),
  updateExpense: (dealId, id, data) => req('PATCH',  `/deals/${dealId}/expenses/${id}`, data),
  deleteExpense: (dealId, id)       => req('DELETE', `/deals/${dealId}/expenses/${id}`),

  // Rooms (SOW)
  addRoom:    (dealId, data)     => req('POST',   `/deals/${dealId}/rooms`, data),
  updateRoom: (dealId, id, data) => req('PATCH',  `/deals/${dealId}/rooms/${id}`, data),
  deleteRoom: (dealId, id)       => req('DELETE', `/deals/${dealId}/rooms/${id}`),

  // SOW sections (upsert)
  updateSowDemo:     (dealId, data) => req('PATCH', `/deals/${dealId}/sow/demo`,      data),
  updateSowSystems:  (dealId, data) => req('PATCH', `/deals/${dealId}/sow/systems`,   data),
  updateSowExterior: (dealId, data) => req('PATCH', `/deals/${dealId}/sow/exterior`,  data),
  updateSowLandscape:(dealId, data) => req('PATCH', `/deals/${dealId}/sow/landscape`, data),

  // SOW cost line items
  syncSowCosts:       (dealId, lines) => req('POST',  `/deals/${dealId}/sow-costs/sync`, lines),
  updateSowCostLine:  (dealId, id, data) => req('PATCH', `/deals/${dealId}/sow-costs/${id}`, data),

  // Mo AI chat
  getChatHistory: (dealId)           => req('GET',  `/deals/${dealId}/chat`),
  chat:           (dealId, messages) => req('POST', `/deals/${dealId}/chat`, { messages }),

  // Photos
  getPhotos:       (dealId)                  => req('GET',    `/deals/${dealId}/photos`),
  updatePhotoNotes:(dealId, photoId, notes)  => req('PATCH',  `/deals/${dealId}/photos/${photoId}`, { notes }),
  deletePhotoImage:(dealId, photoId)         => req('DELETE', `/deals/${dealId}/photos/${photoId}/image`),
  // uploadPhoto + quickUpload use fetch directly (multipart) — see PhotosSection / ChatPanel
};
